<template>
	<v-container fluid>
    <v-row>
      <v-col>
        PROCEDURE
      </v-col>
    </v-row>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
		
		}
	},
}
</script>

<style scoped lang="scss">
	//::v-deep {
	//	.v-dialog {
	//		height: 100% !important;
	//	}
	//}
</style>